import React from 'react';
import {Link} from 'react-router-dom';

import {translate} from 'iss/strings';
import {ActivationList} from 'iss/widgets/ActivationList';
import {PlainRestResultMessage} from 'iss/widgets/MessageBox';

export function BatchOpFailure({message, extraColumns = [], operationResult}) {
  const activations = operationResult.failed.map(({activation, ...rest}) => ({...rest, ...activation}));

  return <React.Fragment>
    <p>{translate(message, {count: operationResult.failed.length})}</p>
    <ActivationList activations={activations} extraColumns={[
      ...extraColumns,
      {
        header: translate('activationOperation.error'),
        accessor: ({id, result}) => <React.Fragment>
          <div style={{color: "red"}}><PlainRestResultMessage result={result} /></div>
          <Link to={"/activatedEvaluations/"+id}>{translate('activationOperation.viewActivation')}</Link>
        </React.Fragment>
      }
    ]} />
</React.Fragment>;
}

export function listFailuresWithMessage(message) {
  return (props) => <BatchOpFailure message={message} {...props} />;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/batchOps/activation/BatchOpFailure.jsx